import { useMutation, useQueryClient } from '@tanstack/react-query';

import { selectActiveAccount, useAuthStore } from '@features/auth';

import { createClient } from '../api/clientsApi';
import type { CreateClientRequest } from '../types';

export function useCreateClient() {
  const queryClient = useQueryClient();
  const activeAccount = useAuthStore(selectActiveAccount);
  const accountId = activeAccount?.accountId ?? '';

  return useMutation({
    mutationFn: (request: CreateClientRequest) => createClient(accountId, request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clients', accountId] });
    },
  });
}
